import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CookieConsentMount } from '@arya/gdpr/cookie-consent/feature';
import { CspNonce } from '@arya/shared/feature';

import { DEV_OVERLAY_COMPONENT } from './dev-surfaces';

@Component({
  imports: [RouterModule, CookieConsentMount, NgComponentOutlet],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-root',
  hostDirectives: [CspNonce],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly devOverlay = DEV_OVERLAY_COMPONENT;
}
